import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const stats = [
  { value: '5,000+', labelKey: 'statsProducts' },
  { value: '200+', labelKey: 'statsBrands' },
  { value: '50万+', labelKey: 'statsCustomers' },
  { value: '200+', labelKey: 'statsCountries' },
];

export default function BrandStory() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Japanese%20storefront%20with%20warm%20lighting%2C%20wooden%20shelves%20displaying%20beauty%20products%2C%20clean%20aesthetic%2C%20warm%20cream%20and%20beige%20tones%2C%20sophisticated%20interior%20design%2C%20high%20quality%20editorial%20photography&width=600&height=700&seq=brand-story-01&orientation=portrait"
                alt="岛国精品品牌店面"
                className="w-full h-64 md:h-80 object-cover rounded-lg"
                loading="lazy"
              />
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20products%20beautifully%20arranged%20on%20minimal%20wooden%20shelves%2C%20skincare%20bottles%2C%20tea%20tins%2C%20ceramic%20cups%2C%20warm%20cream%20wall%20background%2C%20soft%20natural%20lighting%2C%20lifestyle%20photography&width=600&height=700&seq=brand-story-02&orientation=portrait"
                alt="岛国精品精选商品"
                className="w-full h-64 md:h-80 object-cover rounded-lg mt-8"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1">
            <p className="text-accent-600 font-label text-xs tracking-[0.15em] uppercase mb-3">
              OUR STORY
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-5">
              {t('brandStoryTitle')}
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              {t('brandStoryDesc')}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center p-4 rounded-lg bg-background-100">
                  <p className="font-display text-2xl md:text-3xl font-bold text-primary-600 mb-1">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500">
                    {t(stat.labelKey)}
                  </p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              {t('brandStoryCTA')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}